import * as React from 'react'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router-dom'
import {DatePickerV2} from '../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../components/Selection'
import {TRowFilter} from '../../../components/Table/Table'
import {TextInputV2} from '../../../components/TextInputV2'
import {
  ORDER_STATUS,
  ORDER_STATUS_OUTSTANDING,
  REGARDING_OPTIONS,
  SECTOR_OPTIONS,
} from '../../../constants'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {initialState, orderSelector, setOrderFilter} from '../../../redux/slices/orderSlices'
import {useOrderStatus} from 'src/hooks/useOrderStatus'

export const RowFilterOrder = () => {
  const {t} = useTranslation()
  const {salesOrgOptions} = useSalesOrganization()
  const {orderFilter: filter} = useAppSelector(orderSelector)
  const dispatch = useAppDispatch()
  const params = useParams()
  const orderStatusOptions = useOrderStatus()

  const hideFilterStatus = React.useMemo(() => {
    return params.type === 'reject' || params.type === 'amandement' || params.type === 'finish'
  }, [params.type])

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setOrderFilter({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div></div>
      </td>
      <td>
        <TextInputV2
          type='text'
          placeholder={t('order-no')}
          value={filter?.po_number ?? ''}
          onChange={(e: any) => handleChange({po_number: e.target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          startDate={filter?.from_date ?? ''}
          endDate={filter?.to_date ?? ''}
          onChange={({startDate, endDate}) =>
            handleChange({from_date: startDate, to_date: endDate})
          }
        />
      </td>
      <td>
        <TextInputV2
          type='text'
          placeholder={t('order-pelanggan')}
          value={filter?.customer_name ?? ''}
          onChange={(e: any) => handleChange({customer_name: e.target.value})}
        />
      </td>
      <td>
        <Selection
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(value: any) => handleChange({sales_org_code: value})}
        />
      </td>
      <td>
        <Selection
          data={REGARDING_OPTIONS}
          value={filter?.regarding ?? ''}
          onChange={(value: any) => handleChange({regarding: value})}
        />
      </td>
      <td>
        <Selection
          data={SECTOR_OPTIONS}
          value={filter?.sector_id ?? ''}
          onChange={(value: any) => handleChange({sector_id: value})}
        />
      </td>
      <td>
        <TextInputV2
          type='text'
          placeholder={t('Total Kuantum')}
          value={filter?.total_request_quantum ?? ''}
          onChange={({target}) => handleChange({total_request_quantum: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          type='text'
          placeholder={t('Total Price')}
          value={filter?.total_request_price ?? ''}
          onChange={({target}) => handleChange({total_request_price: target.value})}
        />
      </td>
      <td>
        {!hideFilterStatus && (
          <Selection
            data={orderStatusOptions}
            value={filter?.status ?? ''}
            onChange={(value: any) => handleChange({status: value})}
          />
        )}
      </td>
    </TRowFilter>
  )
}

export default React.memo(RowFilterOrder)
